export default __webpack_public_path__ + "static/i1-b5d291999b9c11356e6e21d33001f557.jpg";